import { DisplaySelection } from '../models/DisplaySelection';
import { SearchActionTypes, LoadInitialDisplayAction } from './ActionTypes';

export function loadInitialDisplay(displaySelection: DisplaySelection): LoadInitialDisplayAction {
  return {
    type: SearchActionTypes.LOAD_INITIAL_DISPLAY_MODE,
    displaySelection: displaySelection,
  };
}
